import actions from '@/modules/settings/store/actions'
import getters from '@/modules/settings/store/getters'
import mutations from '@/modules/settings/store/mutations'

export default {
  state: () => ({}),
  actions: actions,
  getters: getters,
  mutations: mutations
}
